module.exports = __webpack_public_path__ + "assets/img/11_481.05543d9a.jpg";